export default "__VITE_ASSET__C3NQcgmx__"